import app from "../_app";


export const openProductPopupHandler = (popup, productTitle) => {
    const productPopup = document.querySelectorAll('.js-product-popup');
    if(productPopup) {
        app.lockBody();
        document.querySelector(`.js-product-popup[data-popup="${popup}"]`).setAttribute('data-open', '');
        var hiddenField = document.querySelector(`.js-product-popup[data-popup="${popup}"]`).querySelectorAll('#hidden-3')[0];
        hiddenField.value = productTitle;
    }
};


const productPopup = [...document.querySelectorAll('.js-product-popup')];

if(productPopup) {
    const closeTriggers = [...document.querySelectorAll('.js-product-popup-close')];

    const closeProductPopupHandler = (e) => {
        e.currentTarget.closest('.js-product-popup').removeAttribute('data-open');
        app.unlockBody();
    };

    closeTriggers.map(closeTrigger => closeTrigger.addEventListener('click', closeProductPopupHandler));
}
